import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Auditor } from "@app/Domain/Models/auditor.model";
import { Survey } from "@app/Domain/Models/survey.model";
import { environment } from "environments/environments";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";
import { SessionStorageService } from "./session-storage.service";

@Injectable({
    providedIn: "root"
})
export class SurveyService extends BaseService {
    private url = environment.BaseUrl + "survey-nps";

    private sessionStorage = inject(SessionStorageService);
    private auditor: Auditor = this.sessionStorage.get("auditor");
    private http = inject(HttpClient);

    getAll(): Observable<Survey[]> {
        return this.http.get<Survey[]>(`${this.url}`, {
            ...this.getHeader(this.auditor.idiomaAuditorInterface)
        });
    }

    getById(id: number): Observable<Survey> {
        return this.http.get<Survey>(`${this.url}/${id}`, this.getHeader(this.auditor.idiomaAuditorInterface));
    }

    create(survey: Survey): Observable<any> {
        return this.http.post(`${this.url}`, survey, this.getHeader(this.auditor.idiomaAuditorInterface));
    }

    update(idSurvey: number, survey: Survey): Observable<any> {
        survey.idSurvey = idSurvey;

        return this.http.put(
            `${this.url}/${idSurvey}`,
            survey,
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }

    delete(idSurvey: number): Observable<any> {
        return this.http.delete(
            `${this.url}/${idSurvey}`,
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
    }
}
